module.exports = __webpack_public_path__ + "static/media/osha.8165abad.png";